import _uniqBy from 'lodash/uniqBy';

import type { Option } from 'shared/models/common';
import type { CaseLevel1Option } from 'shared/models/common-cases';

import { type CooperativeCommonCase } from '../models';

export function getUniqueStatusesList(casesList: CooperativeCommonCase[]) {
  const statusesList: Option[] = [];

  const uniqueCaseList = _uniqBy(casesList, 'Status.Value');

  for (let caseItem of uniqueCaseList) {
    if (caseItem.Status) {
      statusesList.push(caseItem.Status);
    }
  }

  return statusesList;
}

export function getUniqueCaseLevel1List(casesList: CooperativeCommonCase[]) {
  const caseLevel1List: CaseLevel1Option[] = [];

  const uniqueCaseList = _uniqBy(casesList, 'CaseLevel1.Value');

  for (let caseItem of uniqueCaseList) {
    if (caseItem.CaseLevel1) {
      caseLevel1List.push(caseItem.CaseLevel1);
    }
  }

  return caseLevel1List;
}

export function getUniqueYearsList(casesList: CooperativeCommonCase[]) {
  let yearsList: number[] = [];

  for (let caseItem of casesList) {
    if (!caseItem.CreatedOn) continue;

    const year = new Date(caseItem.CreatedOn).getFullYear();

    if (!yearsList.includes(year)) {
      yearsList.push(year);
    }
  }

  return yearsList.sort((a, b) => b - a);
}
